import { CheckboxesPackProps } from './types';

export function getValueFromOptions(newOptions: CheckboxesPackProps['options']) {
  return newOptions.reduce((acc, o) => (o.checked ? [...acc, o.value] : acc), [] as string[]);
}

export const isMixedValue = (value: string[], options: string[]) =>
  Boolean(value.length && value.length < options.length);
